import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);



  const deleteExpenseLimitMasterStatus = getStatus(state, apiKeys.deleteExpenseLimitMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteExpenseLimitMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteExpenseLimitMaster,
      successMsg: formatMessage({ id: "energytype-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-energytype-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);



  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteExpenseLimitMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deleteExpenseLimitMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deleteExpenseLimitMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
